import moment from "moment/moment";

export const RETIREMENT_DATE_PLACEHOLDER = moment('1923-06-01');
export const SIMULATION_END = moment('2150-01-01');
export const STORE_VERSION = 3;
export const DEFAULT_PORTFOLIO_SETTINGS_ID = 'default_portfolio_settings'